// 3rd party
import { Directive, Input, Output, HostBinding, HostListener, EventEmitter, ElementRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[my-dt-column]'
})
export class MyDTColumnDirective {

  @HostBinding('class.sorted-asc') sortedAsc;
  @HostBinding('class.sorted-desc') sortedDesc;

  @Output() onSort: EventEmitter<any> = new EventEmitter();

  _sortOrder: string;
  column: string;

  public sort(order?: string) {
    this._sortOrder = order !== undefined ? order : (!this._sortOrder || this._sortOrder === 'desc') ? 'asc' : 'desc';
    this.sortedAsc = this.sortOrder === 'asc';
    this.sortedDesc = this.sortOrder === 'desc';
  }

  get sortOrder(): string {
    return this._sortOrder;
  }

  get isSorted(): boolean {
    return this._sortOrder !== undefined && this._sortOrder !== null && this._sortOrder !== '';
  }

  @HostBinding('attr.my-dt-column') @Input('my-dt-column')
  set setItem(column: any) {
    this.column = column;
  }

  get setItem() {
    return this.column;
  }

  @HostListener('click') onClick() {
    this.sort();
    this.onSort.emit({ orderBy: this.column, sortOrder: this._sortOrder });
  }

  constructor(private el: ElementRef) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/my-dt/my-dt-column.directive.ts